import { render } from "./VConfirm.vue?vue&type=template&id=129021e7"
import script from "./VConfirm.vue?vue&type=script&lang=js"
export * from "./VConfirm.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projetos Web\\web-vida-vascular\\web-vidavascularjf-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__